import {authFetch} from "../../authentication/authFetch";

const API_URL = process.env.REACT_APP_API_URL;

export async function fetchStats(authToken, timeRange, timezone, date) {
    if (!authToken) return null;

    const query = new URLSearchParams({timeRange, timezone});
    if (date) query.set('date', date);
    const response = await authFetch(`${API_URL}/api/stats?${query}`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-Type': 'application/json',
        },
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch ${timeRange.toLowerCase()} stats`);
    }

    return response.json();
}

export async function fetchProjectStats(authToken, timeRange, timezone, date) {
    if (!authToken) return null;

    const query = new URLSearchParams({timeRange, timezone});
    if (date) query.set('date', date);
    const response = await authFetch(`${API_URL}/api/project-stats?${query}`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-Type': 'application/json',
        },
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch ${timeRange.toLowerCase()} project stats`);
    }

    return response.json();
}

export async function fetchProductivityScoreSeries(authToken, timeRange, timezone) {
    if (!authToken) return [];

    const query = new URLSearchParams({timeRange, timezone});
    const response = await authFetch(`${API_URL}/api/productivity-score-series?${query}`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-Type': 'application/json',
        },
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch ${timeRange.toLowerCase()} productivity score series`);
    }

    return response.json();
}
